import React from "react";

// Contenu du tutoriel de l'écran "Planning" — une seule liste d'étapes (pas
// de variation par profil, contrairement à BureauTutorial.js), affiché par
// le composant générique TutorialOverlay
// (src/components/ui/TutorialOverlay.js).
const planningTutorial = [
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20134202.png",
    title: "La vue calendrier",
    legende: "",
    description: (
      <>
        Le Planning affiche votre semaine en fusionnant deux sources :
        vos <strong>rendez-vous internes MyALFA</strong> et, si vous êtes
        connecté(e), votre <strong>Google Calendar</strong> personnel.
        <br />
        <br />
        Naviguez avec les flèches ou le bouton <strong>« Aujourd'hui »</strong>,
        et basculez entre la vue <strong>« Rendez-vous »</strong> et la vue{" "}
        <strong>« Salles »</strong> (réservations de salles) en haut de
        l'écran.
        <br />
        <br />
        Cliquez sur un créneau pour ouvrir son détail — client, motif, date
        et heure, canal — sans quitter le Planning.
      </>
    ),
  },
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20134226.png",
    title: "Demander l'accès au planning d'un collègue",
    legende: "",
    description: (
      <>
        Le bouton <strong>« + »</strong> permet de rechercher n'importe quel
        collègue et de lui envoyer une <strong>demande d'accès</strong> à son
        planning.
        <br />
        <br />
        Il reçoit un email avec deux liens, <strong>Accepter</strong> ou{" "}
        <strong>Refuser</strong> — vous êtes vous-même prévenu par email de sa
        réponse.
        <br />
        <br />
        Une fois la demande <strong>acceptée</strong>, votre collègue apparaît
        automatiquement sous forme de pastille à cocher : cochez-la pour
        afficher son planning à côté du vôtre.
      </>
    ),
  },
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20134238.png",
    title: "Les paramètres du planning",
    legende: "",
    description: (
      <>
        L'icône <strong>Paramètres</strong> ouvre 5 onglets : vos{" "}
        <strong>créneaux récurrents</strong> de disponibilité, les{" "}
        <strong>jours fériés</strong> pris en compte, les réglages de votre{" "}
        <strong>page de réservation en ligne</strong> (utilisée par vos
        clients/prospects pour prendre RDV), le <strong>partage</strong> de
        votre planning à d'autres collègues, et la gestion des{" "}
        <strong>salles</strong> disponibles à la réservation.
      </>
    ),
  },
];

export default planningTutorial;
